// latest: zhangmyh 2017-10-12 11:36 AM
/* global $ */
const loadingPanel = {
  ele: null,
  show (text) {
    let ele = $('#loading_panel')
    if (ele.length > 0) {
      if (text) {
        ele.find('.loading-text').text(text)
      }
      ele.addClass('running').show()
    } else {
      let loadingText = text || '加载中...'
      ele = $('<div id="loading_panel" class="running"></div>')
      let _ele = $('<div class="loading-mask"></div>')
      ele.append(_ele)
      _ele = $('<div class="loading-content"></div>')
      let __ele = $('<div></div>')
      _ele.append(__ele)
      let ___ele = $('<div class="square"></div>')
      __ele.append(___ele)
      ___ele = $('<div class="loading-text">' + loadingText + '</div>')
      __ele.append(___ele)
      _ele.append(__ele)
      ele.append(_ele)
      $('body').append(ele)
      this.ele = ele
    }
  },
  hide () {
    let ele = $('#loading_panel')
    if (ele.length > 0) {
      ele.removeClass('running').hide()
    } else {
      if (this.ele) {
        this.ele.remove()
        this.ele = null
      } else {
        $('#loading_panel').remove()
      }
    }
  },
  progress (text) {
    let ele
    if (this.ele) {
      ele = this.ele
    } else {
      ele = $('#loading_panel')
      if (ele.length <= 0) {
        return
      }
    }
    ele.find('.loading-text').text(text)
  }
}
export default loadingPanel



// WEBPACK FOOTER //
// ./src/components/loadingPanel/index.js